import React from 'react';
import {Link} from 'react-router-dom';

class Products extends React.Component  {
    render() {
        return(
            <div className="products">
                <section className="feature-section products-section-dark" id="lap">
                    <div className="shape">
                        <img src="image/landing-1-shape.svg" />
                    </div>
                    <div className="container">
                        <div className="section-title text-center">
                            <h2>Our Products</h2>
                        </div>
                        <div className="row justify-content-center align-items-center" id="erickshaw">
                            <div className="col-xl-5 offset-xl-1 col-sm-6 col-10 order-sm-2">
                                <div className="content-img">
                                    <img src="images/sleek_erickshaw_studio.png" alt="" style={{borderRadius: 16, boxShadow: "0 10px 40px rgba(0,0,0,0.4)"}}/>
                                </div>
                            </div>
                            <div className="col-xl-5  col-sm-6 order-sm-1">
                                <div className="content-left-content">
                                    <h2>E-rickshaw Loan</h2>
                                    <p>
                                        Participating in the e-vehicle revolution in India and working towards a greener future, Ascend Capital is one of the first movers in the e-rickshaw financing space.
                                    </p>
                                    <div className="accordian_list">
                                        <div className="row">
                                            <div className="col-12" id="multiCollapseExample5">
                                                <ul className="content-list accordian">
                                                    <li>
                                                        <span><i className="icon icon-check-2"></i></span>Instant approval and same day disbursement
                                                    </li>
                                                    <li>
                                                        <span><i className="icon icon-check-2"></i></span>Affordable EMIs
                                                    </li>
                                                    <li>
                                                        <span><i className="icon icon-check-2"></i></span>Hassle free Insurance and RC process
                                                    </li>
                                                    <li>
                                                        <span><i className="icon icon-check-2"></i></span>Loan Amount - upto 2 lacs repayment
                                                    </li>
                                                    <li>
                                                        <span><i className="icon icon-check-2"></i></span>Tenure - upto 24 months
                                                    </li>
                                                    <li>
                                                        <span><i className="icon icon-check-2"></i></span>Interest rate - starting from 1% per month secured against hypothecated vehicle

                                                    </li>
                                                    <li>
                                                        <span><i className="icon icon-check-2"></i></span>Processing fee - starting from 5% of loan amount
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="header-btns" style={{marginTop: 20}}>
                                        <Link to={"/apply"} className="btn-action-dark">Apply Now</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row justify-content-center align-items-center" id="l5">
                        <div className="col-xl-5  col-sm-6 col-10">
                            <div className="content-img">
                                <img src="images/l5_loader_mahindra_gallery.jpg" alt="L5 Loader" style={{borderRadius: 16, boxShadow: "0 10px 40px rgba(0,0,0,0.4)"}}/>
                            </div>
                        </div>

                        <div className="col-xl-5 offset-xl-1 col-sm-6">
                            <div className="content-right-content">
                                <h2>Light Commercial Vehicle (L5) Loan</h2>
                                <p>Working towards a sustainable future, Ascend Capital is one of the first movers in the Electric Commercial Vehicle financing space.</p>
                                <div className="accordian_list">
                                    <div className="row">
                                        <div className="col-12" id="multiCollapseExample4">
                                            <ul className="content-list accordian">
                                                <li>
                                                    <span><i className="icon icon-check-2"></i></span> Minimum interest rates
                                                </li>
                                                <li>
                                                    <span><i className="icon icon-check-2"></i></span>Affordable EMIs
                                                </li>
                                                <li>
                                                    <span><i className="icon icon-check-2"></i></span>Hassle free Insurance and RC process
                                                </li>
                                                <li>
                                                    <span><i className="icon icon-check-2"></i></span>Loan Amount - upto 4 lacs repayment
                                                </li>
                                                <li>
                                                    <span><i className="icon icon-check-2"></i></span>Tenure - upto 48 months
                                                </li>
                                                <li>
                                                    <span><i className="icon icon-check-2"></i></span>Interest rate - starting from 1% per month secured against hypothecated vehicle
                                                </li> 
                                                <li>
                                                    <span><i className="icon icon-check-2"></i></span>Processing fee - 8000/- + taxes
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="header-btns" style={{marginTop: 20}}>
                                        <Link to={"/apply"} className="btn-action-dark">Apply Now</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row justify-content-center align-items-center" id="electric4wheeler">
                            <div className="col-xl-5 offset-xl-1 col-sm-6 col-10 order-sm-2">
                                <div className="content-img">
                                    <img src="images/electric_4_wheeler.avif" alt="Electric 4 Wheeler" style={{borderRadius: 16, boxShadow: "0 10px 40px rgba(0,0,0,0.4)"}}/>
                                </div>
                            </div>
                            <div className="col-xl-5 col-sm-6 order-sm-1">
                                <div className="content-left-content">
                                    <h2>Electric 4 Wheeler</h2>
                                    <p>
                                        Working towards a sustainable future, Ascend Capital is one of the first movers in the Electric Commercial Vehicle financing space.
                                    </p>
                                    <div className="accordian_list">
                                        <div className="row">
                                            <div className="col-12">
                                                <ul className="content-list accordian">
                                                    <li>
                                                        <span><i className="icon icon-check-2"></i></span>Loan Amount - upto 10 lacs repayment
                                                    </li>
                                                    <li>
                                                        <span><i className="icon icon-check-2"></i></span>Tenure - upto 60 months
                                                    </li>
                                                    <li>
                                                        <span><i className="icon icon-check-2"></i></span>Interest rate - starting from 18% reducing per annum
                                                    </li>
                                                    <li>
                                                        <span><i className="icon icon-check-2"></i></span>Processing fee - 3% of loan amount + taxes
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="header-btns" style={{marginTop: 20}}>
                                        <Link to={"/apply"} className="btn-action-dark">Apply Now</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                </section>

            </div>
        );
    }
}



export default Products;


// WEBPACK FOOTER //
// ./src/components/Products.js